import React, { useMemo } from "react";

import Client from "@searchkit/instantsearch-client";
import { Configure, Hits, InstantSearch, useSearchBox } from "react-instantsearch";
import { Button, Col, Input, InputGroup, Row } from "reactstrap";
import Searchkit, { ESTransporter } from "searchkit";
import { CSRF_TOKEN } from "../util/api";
import { ActionButtons } from "./ActionButtons";
import { DocumentPagination } from "./DocumentPagination";

const makeTransportConfig = (proxyUrl) => {
  return new ESTransporter(
    {
      host: proxyUrl,
      headers: {
        "content-type": "application/x-ndjson",
        "x-csrf-token": CSRF_TOKEN,
      },
    },
    {}
  );
};

function CustomSearchBox() {
  const { query, refine } = useSearchBox();

  return (
    <InputGroup>
      <Input placeholder="Search for file..." value={query} onChange={(e) => refine(e.currentTarget.value)} />
      {query && (
        <Button color="secondary" onClick={() => refine("")}>
          Clear
        </Button>
      )}
    </InputGroup>
  );
}

const ResultRow = ({ fileName, s3Key, s3Bucket }) => (
  <Row className="align-items-center">
    <Col>{fileName}</Col>
    <Col className="text-end">
      <ActionButtons s3Key={s3Key} s3Bucket={s3Bucket} />
    </Col>
  </Row>
);

const HitComponent = ({ hit, downloadUrl }) => {
  const fileName = hit?.file?.fileName || hit?.s3?.key || "Untitled";
  const s3Key = hit?.s3?.key;
  const s3Bucket = hit?.s3?.bucket;
  const href = `${downloadUrl}?inline=true&key=${s3Key}`;

  return (
    <a href={href} className="list-group-item list-group-item-action" style={{ textDecoration: "none" }}>
      <ResultRow fileName={fileName} s3Key={s3Key} s3Bucket={s3Bucket} />
    </a>
  );
};

export const DocumentIndex = ({ downloadUrl, proxyUrl }) => {
  const searchClient = useMemo(() => {
    const sk = new Searchkit({
      connection: makeTransportConfig(proxyUrl),
      search_settings: {
        search_attributes: ["file.fileName", "lab.name", "file.components"],
        result_attributes: ["file.fileName", "lab.name", "file.components", "s3.key", "s3.bucket"],
        highlight_attributes: ["file.fileName"],
      },
    });
    return Client(sk);
  }, [proxyUrl]);

  return (
    <InstantSearch indexName="document-search" searchClient={searchClient}>
      <div className="mb-3">
        <CustomSearchBox />
      </div>

      <Hits
        classNames={{
          root: "bg-white",
          list: "list-group list-group-numbered",
        }}
        hitComponent={(p) => <HitComponent downloadUrl={downloadUrl} {...p} />}
      />

      <DocumentPagination pageSize={20} />
      <Configure hitsPerPage={20} />
    </InstantSearch>
  );
};
